module.exports = __webpack_public_path__ + "static/media/menu.245756fc.svg";